import React, { useState, useEffect, useRef } from "react";

import './Sidebar.css';

import Axios from 'axios';

import { Svg_Menu_Admin, Svg_Menu_Client, Svg_Menu_Exit, Svg_Menu_Project, Svg_Menu_Reports, Svg_Menu_Update, Svg_Point } from "../Svg";

import { GetStatusGlobal, RegisterStatusGlobal, SetStatusGlobal } from "../../interface/Global";

import env from "../../services/Env";
import { OpenPage } from "../../services/OpenPage";
import { ListDataPage } from "../../services/UpdateData";

interface LoginResponse {
    logado: boolean;
}

export default function Page_Sidebar() {

    const initialized = useRef(false);
    const [ currentPage, setCurrentPage ] = useState(GetStatusGlobal('page'));
    const [ currentPageSub, setCurrentPageSub ] = useState(GetStatusGlobal('page_sub'));

    const [ listPage, setListPage ] = useState([
        {
            "name": "Projects",
            "page": "projects",
            "icon": <Svg_Menu_Project className="icon_menu" color="#B1B2B2" />,
            "icon_selected": <Svg_Menu_Project className="icon_menu" color="#EDA13F" />,
            "sub_menu": []
        },
        {
            "name": "Clients",
            "page": "clients",
            "icon": <Svg_Menu_Client className="icon_menu" color="#B1B2B2" />,
            "icon_selected": <Svg_Menu_Client className="icon_menu" color="#EDA13F" />,
            "sub_menu": []
        },
        {
            "name": "Administrators",
            "page": "administrators",
            "icon": <Svg_Menu_Admin className="icon_menu" color="#B1B2B2" />,
            "icon_selected": <Svg_Menu_Admin className="icon_menu" color="#EDA13F" />,
            "sub_menu": []
        },
        {
            "name": "Updates site",
            "page": "updates",
            "icon": <Svg_Menu_Update className="icon_menu" color="#B1B2B2" />,
            "icon_selected": <Svg_Menu_Update className="icon_menu" color="#EDA13F" />,
            "sub_menu": []
        },
        {
            "name": "Reports",
            "page": "reports",
            "icon": <Svg_Menu_Reports className="icon_menu" color="#B1B2B2" />,
            "icon_selected": <Svg_Menu_Reports className="icon_menu" color="#EDA13F" />,
            "sub_menu": [
                {
                    "name": "General",
                    "page": "general",
                },
                {
                    "name": "Units",
                    "page": "units",
                },
                {
                    "name": "Floorplans",
                    "page": "floorplans",
                }
            ]
        }
    ]);

    async function Logout(){
        SetStatusGlobal('dashboard', false);
        SetStatusGlobal('user_name', '');
        SetStatusGlobal('user_file', '');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_file');
        localStorage.removeItem('token');
        
        localStorage.removeItem('page');
        localStorage.removeItem('page_id');
        localStorage.removeItem('page_sub');

        await Axios.post<LoginResponse>(env.apiUrl, {
            type_page: 'logout'
        });
    }

    useEffect(()=>{
        if(localStorage.getItem('page')){
            setCurrentPage(localStorage.getItem('page') as string);
        }
        if(localStorage.getItem('page_id')){
            setCurrentPageSub(localStorage.getItem('page_id') as string);
        }
        if(localStorage.getItem('page_sub')){
            setCurrentPageSub(localStorage.getItem('page_sub') as string);
        }     

        if (initialized.current) return;
        initialized.current = true;
        ListDataPage();

        RegisterStatusGlobal('page', setCurrentPage);
        RegisterStatusGlobal('page_sub', setCurrentPageSub);
    }, []);
    
    return (
        <div className="Page_Sidebar">            
            <div className="div_logo" onClick={ ()=>{ OpenPage('index'); } }>
                <img alt="logo" src="/assets/logo.png" />
            </div>
            <div className="div_opt_menu">
                <div className="topic">ADM Setting</div>
                <div className="list_page">
                    {
                        listPage.map((elem, index)=>{
                            return(
                                <React.Fragment key={ "loop_" + index }>
                                    <div className={ currentPage === elem['page'] || currentPage === elem['page'] + "_details" ? "opt_menu menu_active" : "opt_menu" } onClick={ ()=>{ OpenPage(elem['page']); } } key={ index }>
                                        <div className="div_icons">
                                            {
                                                currentPage === elem['page'] || currentPage === elem['page'] + "_details" ? elem['icon_selected'] : elem['icon']
                                            }
                                        </div>
                                        <div className="name_menu">
                                            { elem.name }
                                        </div>
                                    </div>
                                    {
                                        elem['sub_menu'].length > 0 ?
                                            <div className={ "sub_menu" + (currentPage === elem['page'] && currentPage === 'reports' ? " sub_menu_open" : "") }>
                                                {
                                                    elem['sub_menu'].map((sub_elem, sub_index)=>{
                                                        return(
                                                            <div className={ currentPageSub === sub_elem['page'] ? "opt_menu submenu_active" : "opt_menu" } key={ "sub_loop_" + sub_index } onClick={ ()=>{ OpenPage(elem['page'], '', sub_elem['page']); } }>
                                                                <div className="div_icons">
                                                                    <Svg_Point className="icons" color="#B1B2B2" />
                                                                </div>
                                                                { sub_elem.name }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        : null
                                    }
                                </React.Fragment>
                            )
                        })
                    }
                </div>
                <div className="div_exit" onClick={ ()=>{ Logout(); } }>
                    <div className="div_icons">
                        <Svg_Menu_Exit className="icons" color="#B1B2B2" />
                    </div>
                    <div className="name_menu">Logout</div>
                </div>
            </div>
        </div>
    );
}